import styles from "./Orders.module.css";
import Header from "./Header";
import Footer from "./Footer";
import QrLoading from "./media/qr_loading.png";
import upiIcon from "./media/gpayIcons.png";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {useImagePreview} from "../hooks/useImagePreview";
import {ImagePreview} from "../components/ImagePreview";
import Config from "./Config";

function Orders() {
  const [Loading, setLoading] = useState(true);
  const [Message, setMessage] = useState([]);
  const [MyOrders, setMyOrders] = useState(false);
  const [Refresh, setRefresh] = useState(true);
  const [QR, setQR] = useState(false);
  const [UPILink, setUPILink] = useState(false);
  const [UPIName, setUPIName] = useState("GoodDay");
  const [PopOn, setPopOn] = useState(false);
  const [TID, setTID] = useState("");
  const [Remaining, setRemaining] = useState(0);

  const {fullScreen, openPreview, closePreview} = useImagePreview();

  const messageBox = useRef(null);
  const pop = useRef(null);
  const popDescription = useRef(null);
  const PayButton = useRef(null);
  const sendMessage = (Error, id)=>{
    const link = "https://api.whatsapp.com/send/?phone=91"+Config.whatsAppNumber+"&text=Error%3A"+Error+"%0AOrderID%3A"+id;
    window.location.href=link;
  }

  const {id} = useParams();
  const Lcart = localStorage.getItem("cart");
  const Cart = Lcart?JSON.parse(Lcart):null;
  const CartID = Cart?.id || null;
  const dataSize = MyOrders?MyOrders.dataSize:false;
  const verification = MyOrders?MyOrders.verification:false;
  const name = MyOrders.shipping?MyOrders.shipping.name:"";
  const email = MyOrders.shipping?MyOrders.shipping.email:"";
  const phone = MyOrders.shipping?MyOrders.shipping.phone:"";
  const pincode = MyOrders.shipping?MyOrders.shipping.pincode:"";
  const OrderId = MyOrders.orderId?MyOrders.orderId:false;
  const OrderStatus = MyOrders.orderStatus?MyOrders.orderStatus:false;
  const PaymentStatus = MyOrders.payment?MyOrders.payment.status:false;
  const ShippingCost = MyOrders.pricing?MyOrders.pricing.shippingCost:0;
  const SubTotal = MyOrders.pricing?MyOrders.pricing.total:0;
  const TotalPrice = SubTotal+ShippingCost;

  const upiLink = `orderid=${OrderId?OrderId:""}`;

  let razorpayActive = false;

    const preventBack = (e) => {
      if (razorpayActive) {
        window.history.pushState(null, '', window.location.href);
      }
    };

  const payment_selection = () =>{
    let choice = "razorpay";

    if(choice === "razorpay") {
      handlePay();
    }
    else{
      GenQR();
    }
  }

  const handlePay = async() =>{
    if(PayButton.current) PayButton.current.disabled = true;

    try{
      const res = await fetch(`${Config.NodePath}/api/payment/create-order`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          orderId: OrderId
        })
      });
      const data = await res.json();

      if(!data.success) {
        alert("unable to create order");
        return;
      }

      const {orderId, key} = data;

      const options = {
        key,
        amount: TotalPrice * 100,
        currency: "INR",
        name: Config.siteName,
        description: "Order Payment",
        order_id: orderId,

        handler: async function (response) {
          const verifyRes = await fetch(`${Config.NodePath}/api/payment/verify`, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              order_id: response.razorpay_order_id,
              payment_id: response.razorpay_payment_id,
              signature: response.razorpay_signature,
            })
          });
          const verifyData = await verifyRes.json();

          if(verifyData.success) {
            alert("Payment Successful!");
            setRefresh(true);
          }
          else{
            alert("Payment verification failed!");
          }
        },
        prefill: {
          name: name,
          email: email,
          contact: `+91${phone}`
        },
        modal: {
          onDismiss: function () {
            razorpayActive = false;
            window.removeEventListener('popstate', preventBack);

            alert("payment popup closed");
            if(PayButton.current) PayButton.current.disabled = false;
            if (window.rzp) {
              window.rzp = null;
            }
          }
        },
        theme: {
          color: "#3399cc",
        }
      }
      
      const rzp = new window.Razorpay(options);

      razorpayActive = true;
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', preventBack);

      rzp.open();
    }
    catch(err) {
      console.error(err);
      alert("payment failed to start");
    }
  }

  const GenQR = async () =>{
    if(verification!=="pending") return;
    setPopOn(true);
    try{
      const res = await fetch(Config.NodePath+"/api/qrcode?"+upiLink);
      if(res.ok) {
        const data = await res.json();
        if(data.qr) {
          setQR(data.qr);
        }
        if(data.upi) {
          setUPILink(data.upi);
        }
        if(data.upiName)
        {
          setUPIName(data.upiName);
        }
      }
    }
    catch(err) {
      console.log(err);
    }
  }

  const handleTID = (e) =>{
    const tid = e.target.value;
    setTID(tid);
  }

  const comfirmPayment = async(x) =>{
    if(x) {
      if(TID.length<3) return alert("Please submit transaction ID");
      try{
        const res = await fetch(Config.NodePath+"/api/orders/update", {
          credentials: "include",
          method: "POST",
          headers: {"Content-Type" : "application/json"},
          body: JSON.stringify({
            orderId: OrderId,
            update: "verification",
            data: "processing",
            tid: TID,
            cname: name
          })
        });
        if(res.ok) {
          const data = await res.json();
          if(data.verification) {
            setRefresh(true);
            setPopOn(false);
            setMessage([data.message, "end message"]);
          }
        }
      }
      catch(err) {
        console.log(err);
      }
    }
    else{
      setPopOn(false);
    }
  }

  const ItemData = MyOrders?MyOrders.items?.map((item, index)=>{
    const title = item.title;
    const qty = item.qty;
    const price = item.totalV;
    return (
      <div key={index} className={styles.item}>
        <div className={styles.product}>{title}</div>
        <div className={styles.qty}> {qty}</div>
        <div className={styles.price}>{price.toFixed(2)}</div>
      </div>
    );
  }):"";

  useEffect(() => {
    if(!verification || verification!=="pending" || OrderStatus==="Auto-cancelled") return;
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [OrderStatus, verification]);

  useEffect(()=>{
    const getOrder = async() =>{
      try{
        const res = await fetch(Config.NodePath+"/api/orders/"+id+"?cartid="+CartID, {credentials: "include"});
        if(res.ok) {
          const data = await res.json();
          setMyOrders(data);
          setLoading(false);
          const expiry = ((new Date(data.expiry).getTime() - Date.now())/1000);
          const remaining = expiry>0?Math.floor(expiry):0;
          setRemaining(remaining);
        }
      }
      catch(err) {
        console.log(err);
      }
    }
    if(id && Refresh) {
      setRefresh(false);
      getOrder();
    }
  },[MyOrders, id, Refresh, CartID]);

  useEffect(()=>{
    const timer = setInterval(()=>{
      const expiry = ((new Date(MyOrders.expiry).getTime() - Date.now())/1000);
      const remaining = Math.max(0, Math.floor(expiry));
      setRemaining(prev=>{
        if(prev<=0) {
          setPopOn(false);
          clearInterval(timer);
        }
        return remaining;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [MyOrders.expiry]);

  useEffect(()=>{
    if(PopOn) {
      document.body.classList.add(styles.noScroll);
      if(pop.current) {
        popDescription.current.scrollTop = 0;
        pop.current.classList.add(styles.open);
      }
      if(PayButton.current) PayButton.current.disabled = true;
    }
    else{
      document.body.classList.remove(styles.noScroll);
      if(pop.current) pop.current.classList.remove(styles.open);
      if(PayButton.current) PayButton.current.disabled = false;
    }
  }, [PopOn]);

  useEffect(()=>{
    if(Message) {
      messageBox.current.classList.add(styles.show);
      const msg = setTimeout(()=>{
        messageBox.current.classList.remove(styles.show);
      }, 2500);
      return ()=> clearTimeout(msg);
    }
  }, [Message]);


  return(
    <>
    {<Header />}
    <div className={`${styles.fullWrapper}`}>
      <div className={Loading?styles.loading:""}></div>
      <div className={styles.MessageWrapper}>
        <div ref={messageBox} className={styles.message}>
          {Array.isArray(Message)?Message.map((item,index)=>{if(index!==Message.length-1) return(<span key={index}>{item}</span>); else return null}):""}
        </div>
      </div>
      {MyOrders.verification&&(MyOrders.verification==="processing" || MyOrders.verification==="approved")?
      <div className={`${styles.order} ${styles.note}`}>
        &#x2B50; Please Bookmark this page to track your order
      </div>:""}
      <div className={`${styles.order} ${styles.orderTitle}`}>{OrderId?"Order ID: "+OrderId: "Order not found!"}</div>

      <div className={`${styles.order} ${styles.itemTile}`}>
        <div className={styles.name}>
            <span>Customer: {name?""+name:""}</span>
          <span>Location: {pincode?""+pincode:""}</span>
        </div>
      </div>

      <div className={`${styles.order} ${styles.itemTile}`}>
        <div className={styles.item}>
          <div className={`${styles.product} ${styles.title}`}>Product</div>
          <div className={`${styles.qty} ${styles.title}`}> Qty</div>
          <div className={`${styles.price} ${styles.title}`}>Price</div>
        </div>
        {ItemData?ItemData:"No items found!"}
      </div>

      <div className={`${styles.order} ${styles.itemTile}`}>
        <div className={styles.item}>
          <div className={`${styles.product}`}>Sub Total</div>
          <div className={`${styles.qty}`}></div>
          <div className={`${styles.price}`}>{SubTotal?SubTotal.toFixed(2):""}</div>
        </div>
        <div className={styles.item}>
          <div className={`${styles.product}`}>Shipping charge</div>
          <div className={`${styles.qty}`}></div>
          <div className={`${styles.price}`}>{ShippingCost?ShippingCost.toFixed(2):""}</div>
        </div>
      </div>

      <div className={`${styles.order} ${styles.itemTile}`}>
        <div className={styles.total}>
          Total: ₹{TotalPrice?TotalPrice.toFixed(2):0}
        </div>
      </div>
      <div className={`${styles.order} ${styles.status}`}>
        <div>
            Order Status: 
            {OrderStatus&&OrderStatus==="placed"?(<span className={styles.orange}> {OrderStatus}</span>):""}
            {OrderStatus&&(OrderStatus==="confirmed" || OrderStatus==="packed" || OrderStatus==="shipped")?(<span className={styles.green}> {OrderStatus}</span>):""}
            {OrderStatus&&OrderStatus==="delivered"?(<span className={styles.blue}> {OrderStatus}</span>):""}
            {OrderStatus&&(OrderStatus==="Auto-cancelled" || OrderStatus==="cancelled")?(<span className={styles.blue}> {OrderStatus}</span>):""}
        </div>
        {OrderStatus&&OrderStatus!=="Auto-cancelled" && OrderStatus!=="cancelled"?
        <div>
            Payment status:
            {PaymentStatus&&PaymentStatus==="pending"?(<span className={styles.orange}> {PaymentStatus}</span>):""}
            {PaymentStatus&&PaymentStatus==="paid"?(<span className={styles.green}> {PaymentStatus}</span>):""}
            {PaymentStatus&&PaymentStatus==="failed"?(<span className={styles.red}> {PaymentStatus}</span>):""}
            {PaymentStatus&&PaymentStatus==="refunded"?(<span className={styles.blue}> {PaymentStatus}</span>):""}
        </div>
        :""}
        {dataSize&&dataSize===1&&verification==="pending"?(
          <div>
            <button className={styles.cancelOrder}>Cancel Order</button>
            <button className={styles.cancelOrder}>Edit</button>
          </div>
        ):""}
      </div>
      <div className={`${styles.order} ${styles.payment}`}>
        
        {verification&&verification==="pending"&&OrderStatus!=="Auto-cancelled"?(
          <>
          <div className={styles.expiryTimer}>Expires: {`${Math.floor(Remaining/60)}:${Math.floor(Remaining % 60).toString().padStart(2, "0")}`}</div>
          {Remaining>0?<button ref={PayButton} className={styles.pay} name="PayButton" onClick={payment_selection}>Complete Payment</button>:<>Cart expired, If you made any payment, contact us. <button className={styles.whatsapp} onClick={()=>sendMessage("Cart Expired", OrderId)}>WhatsApp</button></>}
          </>
        ): ""}
        {verification&&verification==="pending"&&OrderStatus==="Auto-cancelled"?(
          <>
          Cart expired, If you made any payment, contact us.
          <button className={styles.whatsapp} onClick={()=>sendMessage("Cart Expired", OrderId)}>WhatsApp</button>
          </>
        ): ""}
        {verification&&verification==="processing"?(
          <>
          <span className={styles.verificationStatus}>Order Processing..</span>
          Your payment is being verified manually. This may take up to 2 hours. Please bookmark this page and check again later.
          <b>You will receive an email once your order is confirmed.</b>
          </>
        ): ""}
        {verification&&verification==="rejected"?(
          <>
          <span className={styles.verificationStatus}>Order Rejected!</span>
          We did not receive your payment. This could be cause of an error!
          <span className={styles.note}>Your order did not processed! You may create a new order now.<br/>
          If the amount is deducted from your account, please contact your bank! If the payment was successful, please send a message to us via WhatsApp.
          <button className={styles.whatsapp} onClick={()=>sendMessage("Order Rejected", OrderId)}>WhatsApp</button>
          </span>
          </>
        ): ""}
        {verification&&verification==="approved"?(
          <>
          <span className={styles.verificationSuccess}>Payment Completed</span>
          Your Order {OrderStatus?"has "+OrderStatus:"status is unavailable"}. {OrderStatus!=="delivered"&&OrderStatus!=="cancelled"?"Please wait for further updates..":""}
          </>
        ): ""}
        {verification&&verification==="mismatch"?(
          <>
          <span className={styles.verificationStatus}>Payment Mismatch</span>
          The payment received does not match the order amount!
          <span className={styles.note}>
            We received your payment, but the amount does not match the order total. Our team will review the payment and issue a refund if necessary.<br/>
            If you have any questions, you may contact us through WhatsApp for further clarification.
          <button className={styles.whatsapp} onClick={()=>sendMessage("Payment Mismatch", OrderId)}>WhatsApp</button>
          </span>
          </>
        ): ""}
        
      </div>
      
      <div className={`${styles.order}`}>
        <a href="/contact" title="send a message">Trouble? Let us know..</a>
      </div>
    </div>
    <div ref={pop} className={styles.pop}>
      <div className={styles.box}>
        <button className={styles.closeButton} onClick={()=>comfirmPayment(false)}>X</button>
        <div className={styles.qrBox}>
            <div className={styles.qrImg}>
              <div className={styles.qrImage}>
                <img src={QR?QR:QrLoading} alt="QR code"/>
              </div>
            </div>
            <div className={styles.text}>
              {UPILink?(
                <a className={styles.img} href={UPILink} title="open payment app">
                <img src={upiIcon} alt="upi" />
                </a>
              ):""}
                
              <span>UPI payment / Scan here
                <div className={styles.timer}>Expires: {`${Math.floor(Remaining/60)}:${Math.floor(Remaining % 60).toString().padStart(2, "0")}`}</div>
              </span>
              
            </div>
        </div>
        <div className={styles.copyOrderId}>
          {UPILink?(
            <>
            <a href={UPILink} title="open payment app">
              Choose Payment App
            </a>
            </>
            ):""}
        </div>
        <div ref={popDescription} className={styles.description}>
          <div className={styles.steps}>
            <span className={styles.span}>1️⃣ Send <b>₹{TotalPrice?TotalPrice.toFixed(2):0}</b> to <b>{UPIName}</b></span>
            <span className={styles.span}>2️⃣ Copy the UPI Transaction ID</span>
            <span className={styles.span}>3️⃣ Paste it below and submit</span>
          </div>
          <span><input className={styles.transactionID} onChange={handleTID} value={TID} title="enter transaction ID" type="text" placeholder="Transaction ID" /></span>
          <button className={styles.pay_btn} title="Confirm" disabled={Remaining>0?false:true} onClick={()=>comfirmPayment(true)}>
            SUBMIT
            </button>
            
            <div className={styles.paymentGuide}>
              <img src="../images/payment_steps.png" alt="payment guide" onClick={()=>openPreview("../images/payment_steps.png")} />
            </div>
            <div className={styles.guide}>
              <ul>
                <li>Please scan the QR code using payment app <span className={styles.mobileOnlyText}>/ click on 'Choose Payment App' button</span>. Make sure the name and amount match what is shown on the screen.</li>
                <li>After completing the payment, copy the transaction id from your payment app and paste it above and press submit.</li>
                <li>Once you click the “Submit” button, your order will be placed for manual confirmation.</li>
              </ul>
              💡 You will receive a confirmation on your Email.
            </div>
        </div>
      </div>
    </div>
    {<ImagePreview fullScreen={fullScreen} onClose={closePreview} />}
    {<Footer />}
    </>
  );
}
export default Orders;